import { defineComponent as _defineComponent } from 'vue'
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import ProfileSection from '@/views/profile/components/ProfileSection.vue';
import useProfileState from '@/state/profile/profileState';
import { computed, toRefs } from 'vue';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileInvitedBy',
  props: {
  isEmployee: Boolean,
  isGuest: Boolean
},
  setup(__props) {

const props = __props;



const { t } = useI18n();
const { profile, isQuickInfo } = useProfileState();
const { isGuest, isEmployee } = toRefs(props);
const user = computed(() => {
  if (isGuest.value) return profile.value?.company;
  return profile.value?.basic?.invitedBy;
});

const userId = computed(() => {
  if (user.value) {
    if (isGuest.value && 'rootUserId' in user.value) return user.value?.rootUserId ?? '';
    return user.value?.id ?? (('userId' in user.value) ? user.value?.userId : undefined) ?? '';
  }
  return null;
});

const headline = computed<string>(() => {
  if (isGuest.value) {
    return t('profile.common.guestOf').toString();
  }
  if (isEmployee.value) {
    return t('profile.common.employeeOf').toString();
  }
  return t('profile.common.invitedBy').toString();
});


return { __sfc: true,props, t, profile, isQuickInfo, isGuest, isEmployee, user, userId, headline, BCXUserBanner, ProfileSection }
}

})